export default "__VITE_ASSET__2a08a5d3__"